export default {
  namespaced: true,
  state : {
    active: false
  },
  mutations: {
    showModal: (state) => state.active = true,
    closeModal: (state) => state.active = false
  }
}